
import store from 'Redux/store';

const SPLIT_TEST = 'frontend/split-test/SPLIT_TEST';
/**
 * Dispatch split test side to redux/snowplow
 */

const reportSplitTrigger = (experimentName, variant) => {
  store.dispatch({ type: SPLIT_TEST, payload: { experimentName, variant } });
};

export {
  reportSplitTrigger, // eslint-disable-line import/prefer-default-export
};
